import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Select from 'Components/Select'
import ApiRequest from 'EurestoApi/ApiRequest'
import project from 'EurestoConfig/project.config'
import Utils from 'EurestoFonction/Utils'
import useAxiosCancelToken from 'EurestoHook/useAxiosCancelToken'

export default React.memo((props) => {

  const [key, setKey] = useState(Utils.getRandomNumber(), [props.recherche])
  const [keyResult, setKeyResult] = useState(Utils.getRandomNumber())
  const [input, setInput] = useState(props.input || '')
  const [result, setResult] = useState([])
  const [value, setValue] = useState(props.value || props.multi && [] || null)

  useEffect(() => {
    setInput('')
    setValue(null)
    setKey(Utils.getRandomNumber())
  }, [props.resetInput])
  useEffect(() => {
    setValue(props.value || props.multi && [] || null)
  }, [props.value])


  const { data, loading } = useAxiosCancelToken(props.path, props.requete, 'list', {
    recherche: Utils.searchJsonToRechercheArray({
      [props.search]: input,
      ...(props.recherche || {})
    }),
    ...(props.limit && {
      limit: props.limit,
      offset: 0
    } || {})
  }, key)


  const onChangeInput = useCallback(d => {
    setInput(d)
    setKey(Utils.getRandomNumber())
  }, [input])

  const getContact = async (search, params) => {
    params = params || {
      limit: props.limit,
      offset: 0,
    }
    console.log(params)
    search = EurestoClone(search)
    return await ApiRequest(project.api + props.path, {
      requete: props.requete,
      action: 'list',
      ...params,
      recherche: Utils.searchJsonToRechercheArray(search)
    })
  }

  useEffect(() => {
    const getResults = async () => {
      console.log(props.limit)
      const rows = (props.multi ? value && value.length > 0 : value) && await getContact({
        [props.id || 'id']: value
      }, {
        limit: props.limit,
        offset: 0
      })
      console.log(rows)
      rows && setResult(rows.results || [])
      rows && setKeyResult(Utils.getRandomNumber())
      console.log(value)
    }
    if (props.multi ? value && value.length > 0 : value) {
      getResults()
    }
  }, [value])

  const onSelect = useCallback((d) => {
    if (props.multi) {
      setResult(data.filter(da => d.indexOf(da.id) !== -1))
      setValue(d)
      props.onChange(d, props.name, data.filter(da => d.indexOf(da.id) !== -1))
    } else {
      setResult(data.filter(da => da.id === d))
      setValue(d)
      props.onChange(d, props.name, data.filter(da => da.id === d))
    }
  }, [result, value, data])

  const options = useMemo(() => (props.recherche || (input && input.length > 2) || value) && [
    ...(props.optionsPosition !== 'last' && props.options || []),
    ...(((input && input.length > 2) || value) && ((result || []).filter(r => (data || []).findIndex(d => d.id === r.id) === -1)).concat(data || []).map((d, i) => (props.optionFunc ? props.optionFunc(d, i) : ({
      label: d.libelle,
      value: d.id,
      html: <strong>{d.libelle}</strong>
    }))) || []),
    ...(props.optionsPosition === 'last' && props.options || []),
  ] || props.options || [], [props.recherche, input, result, data, props.options])

  console.log(options, props.recherche)

  return <Select disabled={props.disabled}
    InputProps={props.InputProps}
    className={props.className}
    classNameModal={props.classNameModal}
    placeholder={props.placeholder}
    MenuProps={props.MenuProps}
    autoFocus={props.autoFocus}
    loading={input && input.length > 3 && loading}
    menuMaxHeight={props.menuMaxHeight}
    key={keyResult}
    value={value || input}
    inline={props.inline}
    title={props.title}
    options={options}
    onChangeText={onChangeInput}
    inputStyle={props.style || {}}
    onChange={onSelect} />
})



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/InputSearch/index.js